module.exports = __webpack_public_path__ + "img/mobile-app-download-qr.401641c3.png";